import React from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { compose } from '@reduxjs/toolkit';
import { Box } from '@drone-js/core';
import { connectFromCrossSellWidget, UnlockTripSavingsBanner as TripUnlockTripSavingsBanner } from '@cart-js/trip';
import { QueryString } from 'core/utils/queryString/queryString';
import {
    UnlockTripSavingsBannerPropsOwnProps,
    UnlockTripSavingsBannerProps,
    mapTripStateToProps,
    mapActivitiesStateToProps,
    mapDispatchToProps,
    mapActivitiesStateToShouldRender,
} from 'component/page/search/UnlockTripSavingsBanner/UnlockTripSavingsBanner.selector';
import { isInPositiveInt32Range } from 'core-framework/util/CommonUtils';
import { withCrossSellWrapper } from 'core/context/CrossSellWrapper/withCrossSellWrapper';
import { withErrorBoundary } from 'component/common/Hoc/ErrorBoundary';

const UnlockTripSavingsBannerComponent: React.FC<UnlockTripSavingsBannerProps> = (props) => {
    const { outerBoxProps = {}, innerBoxProps = {}, isBannerVisible, pageTypeId, setCid } = props;
    const locationSearch = useLocation().search;
    const navigate = useNavigate();

    const onRefresh = React.useCallback(
        (cid: string) => {
            const parsedCid = parseInt(cid, 10);
            if (isInPositiveInt32Range(parsedCid)) {
                setCid(parseInt(cid, 10));
                const query = new QueryString(locationSearch);
                query.set('cid', cid);
                navigate(`?${query}`, { replace: true });
            }
        },
        [navigate, locationSearch, setCid],
    );

    return (
        <Box {...(isBannerVisible && outerBoxProps)}>
            <Box {...(isBannerVisible && innerBoxProps)}>
                <TripUnlockTripSavingsBanner pageTypeId={pageTypeId.toString()} onRefresh={onRefresh} />
            </Box>
        </Box>
    );
};
UnlockTripSavingsBannerComponent.displayName = 'UnlockTripSavingsBannerComponent';

const UnlockTripSavingsBanner = compose<React.FC<UnlockTripSavingsBannerPropsOwnProps>>(
    withCrossSellWrapper(mapActivitiesStateToShouldRender),
    connectFromCrossSellWidget(mapTripStateToProps),
    connect(mapActivitiesStateToProps, mapDispatchToProps),
)(withErrorBoundary(UnlockTripSavingsBannerComponent));
UnlockTripSavingsBanner.displayName = 'UnlockTripSavingsBanner';

export { UnlockTripSavingsBannerComponent, UnlockTripSavingsBanner };
